module.exports = __webpack_public_path__ + "media/mapv_1791549768427_74300.37cc5daa.mp4";